var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesOrderone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 7,
    fill: "#FFF7E0",
    stroke: "#334456",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9974 18.3359C17.3786 18.3359 16.7851 18.5818 16.3475 19.0194C15.9099 19.4569 15.6641 20.0504 15.6641 20.6693C15.6641 21.2881 15.9099 21.8816 16.3475 22.3192C16.7851 22.7568 17.3786 23.0026 17.9974 23.0026C18.6162 23.0026 19.2097 22.7568 19.6473 22.3192C20.0849 21.8816 20.3307 21.2881 20.3307 20.6693C20.3307 20.0504 20.0849 19.4569 19.6473 19.0194C19.2097 18.5818 18.6162 18.3359 17.9974 18.3359ZM16.9974 20.6693C16.9974 20.4041 17.1028 20.1497 17.2903 19.9622C17.4778 19.7746 17.7322 19.6693 17.9974 19.6693C18.2626 19.6693 18.517 19.7746 18.7045 19.9622C18.892 20.1497 18.9974 20.4041 18.9974 20.6693C18.9974 20.9345 18.892 21.1888 18.7045 21.3764C18.517 21.5639 18.2626 21.6693 17.9974 21.6693C17.7322 21.6693 17.4778 21.5639 17.2903 21.3764C17.1028 21.1888 16.9974 20.9345 16.9974 20.6693Z",
    fill: "#334456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 13.4088L19.5647 10.4375L11.772 16.6628L11.34 16.6582V16.6648H11V24.6648H25V16.6648H24.3587L23.0827 12.9322L21.684 13.4088ZM22.95 16.6648H16.2647L21.244 14.9675L22.2587 14.6428L22.95 16.6648ZM20.3667 13.8582L15.2267 15.6102L19.2973 12.3582L20.3667 13.8582ZM12.3333 22.1108V19.2175C12.6146 19.1178 12.8701 18.9566 13.0811 18.7457C13.2922 18.5348 13.4535 18.2794 13.5533 17.9982H22.4467C22.5464 18.2795 22.7077 18.535 22.9188 18.746C23.1299 18.9571 23.3854 19.1184 23.6667 19.2182V22.1115C23.3854 22.2113 23.1299 22.3726 22.9188 22.5836C22.7077 22.7947 22.5464 23.0502 22.4467 23.3315H13.5547C13.4548 23.05 13.2933 22.7943 13.082 22.5831C12.8707 22.3719 12.6149 22.2106 12.3333 22.1108Z",
    fill: "#334456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOrderone);
export default __webpack_public_path__ + "static/media/sales_orderone.7b8c9d7c12b1f2f6639fd0f21b2e2276.svg";
export { ForwardRef as ReactComponent };